
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link } from '@ta-interaktiv/contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Sars-CoV-19 ist relativ einfach übertragbar. Infektionsmediziner Jeremy
Farrar sagt: «Was wir gerade sehen, ist beispiellos. Ich weiss von keinem
Ausbruch in den letzten 100 Jahren, der sich so schnell so weit ausgebreitet hat.»
Die Ansteckungsgefahr eines Virus wird durch den sogenannten R0-Wert bestimmt, der
angibt, wie viele ­weitere Menschen ein einzelner Infizierter ansteckt. Die ETH
berechnete mit einem Computermodell, dass eine mit dem Coronavirus infizierte
Person im Durchschnitt zwischen 2 und 3,5 weitere Menschen ansteckt.
Christian Althaus, Epidemiologe an der Universität Bern, vermutet, dass der R0-Wert bei 2.2 liegt.
`}<strong parentName="p">{`Das Coronavirus ist ansteckender als die saisonale Grippe mit einem `}<Link disco href='https://www.pnas.org/content/112/9/2723' mdxType="Link">{`R0-Wert von 1,3 bis 2`}</Link>{`.`}</strong>{` Solange
der R0-Wert eines Virus grösser als 1 ist, kann es sich weiter in der Bevölkerung
ausbreiten. In der am stärksten betroffenen chinesischen Stadt Wuhan wurde laut
einer `}<Link disco href='https://drive.google.com/file/d/1-sq-yyGMHiSy_T4HfjOl_PDMMJWnUMZs/view?usp=sharing' mdxType="Link">{`Studie`}</Link>{`
dieser Durchschnitt von 2,35 vor dem Reiseverbot am 29. Januar auf 1,05 gesenkt. «Aber ein solcher Wert lässt sich nur mit drastischen Massnahmen erreichen», sagt Marcel Salathé, Epidemiologie-Professor an der ETH in Lausanne. «Die aktuellsten R0-Werte in Wuhan werden
mit 0,3 angegeben», sagt Althaus. Sobald aber die gegenwärtigen Quarantäne-Massnahmen aufgehoben würden, könne die Ansteckungsrate wieder steigen.
Wie stark konnte die Verbreitung in der Schweiz bereits reduziert werden? Althaus sagte
am 3. April: «Unsere aktuelle Berechnung zeigt, dass die Reproduktionszahl möglicherweise
unter 1 gedrückt werden konnte, also unter die Schwelle, welche eine weitere Ausbreitung
des Virus begünstigt.»`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;